import { FC, ReactNode } from "react";
import { ConfigProvider } from "antd";

const StylesProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ConfigProvider
      button={{
        style: {
          boxShadow: "none",
        },
      }}
      theme={{
        token: {
          colorPrimary: "#00AA5C",
          colorPrimaryHover: "#00934F",
          colorPrimaryActive: "#00934F",
          borderRadius: 4,
        },
        components: {
          Button: {
            controlHeight: 40,
            colorText: "#00AA5C",
            colorBorder: "#00AA5C",
          },
          Input: {
            controlHeight: 40,
          },
          InputNumber: {
            controlHeight: 40,
          },
          DatePicker: {
            controlHeight: 40,
          },
          Select: {
            controlHeight: 40,
            borderRadius: 4,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default StylesProvider;
